import React from 'react'
import { CustomInput } from '../../../components/custom-input/CustomInput'

interface UserInfoProps {
  name: string
  setName: (value: string) => void
  phone: string
  setPhone: (value: string) => void
  errorState: { name: boolean; phone: boolean }
  t: (key: string) => string
}

const UserInfo: React.FC<UserInfoProps> = ({
  name,
  setName,
  phone,
  setPhone,
  errorState,
  t,
}) => (
  <div className='checkout-page__fields'>
    <CustomInput
      label={t('NAME')}
      error={!errorState.name}
      helperText={!errorState.name ? t('FIELD_REQUIRED') : undefined}
      value={name}
      fullWidth
      variant='filled'
      autoComplete='name'
      onChange={(e) => setName(e.target.value)}
    />
    <CustomInput
      label={t('PHONE')}
      type='tel'
      error={!errorState.phone}
      helperText={!errorState.phone ? t('FIELD_REQUIRED') : undefined}
      value={phone}
      fullWidth
      variant='filled'
      autoComplete='tel'
      inputProps={{ inputMode: 'tel' }}
      onChange={(e) => setPhone(e.target.value)}
    />
  </div>
)

export default UserInfo
